<template>
  <div class="tools" :style="{ zoom: screenIndexWidth < 1600 ? 0.8 : 1 }">
    <div class="tools-box">
      <div class="intention-box"></div>
      <slot name="contrast"></slot>
      <div
        class="tools-box-li"
        @click="
          $router.push({
            path: '/land/releaseNeed',
          })
        "
      >
        <div class="tools-box-li-img">
          <img :src="require('@/assets/images/tools/ziyuanxuqiu.png')" alt="" />
        </div>
        <div class="tools-box-li-title">提交需求</div>
      </div>

      <el-tooltip placement="left" effect="light">
        <div slot="content" class="tools-box-li-ewm">
          <img src="../../../assets/images/mobie.png" alt="" />
        </div>
        <div class="tools-box-li">
          <div class="tools-box-li-img">
            <img :src="require('@/assets/images/tools/shouji.png')" alt="" />
          </div>
          <div class="tools-box-li-title">手机查看</div>
        </div>
      </el-tooltip>
      <el-tooltip placement="left" effect="light">
        <div slot="content" class="tools-box-li-about">
          <div class="tools-box-li-about-li">版权所有：云南省自然资源厅</div>
          <div class="tools-box-li-about-li" style="display: flex">
            <div>技术支持：</div>
            <div>
              <div>云南省测绘资料档案馆(云南省基础地理信息中心)</div>
              <div>贵州图智信息技术有限公司</div>
              <div>云南图源科技有限公司</div>
            </div>
          </div>
          <div class="tools-box-li-about-li">技术服务热线：xxxx-xxxxxx</div>
          <div class="tools-box-li-about-li">更新时间：{{ updateTime }}</div>
        </div>
        <!-- <div class="tools-box-li">
          <div class="tools-box-li-img">
            <img
              :src="require('@/assets/images/tools/guanyuwomen.png')"
              alt=""
            />
          </div>
          <div class="tools-box-li-title">关于我们</div>
        </div> -->
      </el-tooltip>
      <div class="tools-box-li" @click="toTop">
        <div class="tools-box-li-img">
          <img
            :src="require('@/assets/images/tools/fanhuidingbu.png')"
            alt=""
          />
        </div>
        <div class="tools-box-li-title">回到顶部</div>
      </div>
    </div>
  </div>
</template>
<script>
import intention from "@/components/currency/intention";
export default {
  components: {
    intention,
  },
  data() {
    return {
      screenIndexWidth: null,
      list: [
        {
          title: "提交需求",
          img: require("@/assets/images/tools/ziyuanxuqiu.png"),
        },
        { title: "手机查看", img: require("@/assets/images/tools/shouji.png") },
        {
          title: "关于我们",
          img: require("@/assets/images/tools/guanyuwomen.png"),
        },
        {
          title: "回到顶部",
          img: require("@/assets/images/tools/fanhuidingbu.png"),
        },
      ],
      updateTime: systemConfig.updateTime,
    };
  },
  mounted() {
    this.screenIndexWidth = window.screen.width; //初始化网页宽度
  },
  methods: {
    //回到顶部
    toTop() {
      this.$nextTick(() => {
        // let app = document.getElementById("app");
        // console.log(app.scrollTop, "===");
        // app.scrollTop = 0;
        let app = document.getElementById("app");
        let top = app.scrollTop;
        const timeTop = setInterval(() => {
          app.scrollTop = app.scrollTop = top -= 10;
          if (top <= 0) {
            clearInterval(timeTop);
          }
        }, 10);
      });
    },
  },
};
</script>
<style scoped>
.tools {
  position: fixed;
  top: 40%;
  right: 40px;
  background: #ffffffc9;
  padding: 0 10px;
  border-radius: 6px;
}
.tools-box {
}
.tools-box-li {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
  cursor: pointer;
}
.tools-box-li-img {
  width: 30px;
  height: 30px;
}
.tools-box-li-img > img {
  width: 100%;
  height: 100%;
}
.tools-box-li-title {
  font-size: 0.75rem;
}
.tools-box-li-ewm > img {
  width: 150px;
}
.tools-box-li-about-li {
  padding: 5px 10px;
}
.intention {
  background: transparent !important;
}
</style>